import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';


import { WebImageGalleryComponent } from './web-image-gallery.component';
import { ImageContainerComponent } from './image-container/image-container.component';
import { CustomMaterialModule } from '@sk/custom-material';
import { ShowImageDialogModule } from '../../../components/dialogs/show-image-dialog/show-image-dialog.module';


@NgModule({
  declarations: [WebImageGalleryComponent, ImageContainerComponent],
  imports: [CommonModule, CustomMaterialModule, FlexLayoutModule, ShowImageDialogModule],
  exports: [WebImageGalleryComponent, ImageContainerComponent]
})
export class WebImageGalleryModule {}
